import React, { useContext } from 'react';
import Favourite from '../../Favourite';

const Intro = ({
  intro: { title, ask },
  id,
  currentNav,
  selectedDeparture,
}) => {
  return (
    <div className="c-online-booking__intro">
      <div
        className={`o-summary ${
          currentNav.slug !== 'departures'
            ? 'o-summary--selected-departure'
            : ''
        }`}
      >
        <p className="o-summary__type">{title.type}</p>

        <h2
          className="o-summary__title"
          dangerouslySetInnerHTML={{ __html: title.title }}
        ></h2>

        {currentNav.slug === 'departures' ? (
          <>
            <p className="o-summary__price">
              {title.details} from{' '}
              <strong className="o-summary__price__strong">
                {title.price.display}
              </strong>
              <Favourite id={id} type={'holiday'} />
            </p>

            <p></p>

            <p className="o-summary__tags">{title.tags}</p>
          </>
        ) : (
          <div className="o-summary__details">
            <div className="o-summary__details__start-date">
              <p className="u-mb-2">Start Date</p>

              <p>{selectedDeparture.start_date}</p>
            </div>

            <div className="o-summary__details__end-date">
              <p className="u-mb-2">End Date</p>

              <p>{selectedDeparture.end_date}</p>
            </div>

            <div className="o-summary__details__price">
              <p className="u-mb-2">Price pp</p>

              <p
                className="u-weight--bold"
                dangerouslySetInnerHTML={{
                  __html: selectedDeparture.price.display,
                }}
              ></p>
            </div>
          </div>
        )}
      </div>

      <div className="c-online-booking__ask o-ask u-hidden-until@tablet">
        <div className="c-online-booking__ask__box">
          <h4 className="o-ask__title">
            Do you have a question about this tour?
          </h4>

          <a
            href="https://www.journeylatinamerica.com/contact-us/?hol=30621"
            className="o-ask__link"
          >
            Ask about this trip
            <span role="presentation" className="o-ask__link__arrow"></span>
          </a>

          <p className="c-online-booking__ask__body o-ask__body">
            Or speak to an expert on
            <a
              href="tel:+442037332807"
              data-ict-discovery-number="0208 747 8315"
              data-ict-silent-replacements="true"
              className="o-ask__phone InfinityNumber"
            >
              <span className="InfinityNumber">020 3733 2807</span>
            </a>
          </p>

          <div className="c-online-booking__ask__aito">
            <img src={`${ASSET_DIR}/images/aito.png`} alt="aito" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
